import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import GalleryComponent from './components/GalleryComponent';
import Testimonials from './components/Testimonials';
import Login from './components/Login';
import Footer from './components/Footer';
import Nav from './components/Nav';
import Career from './components/Career';
import Checklist from './components/Checklist';
import GalleryPage from './components/GalleryPage';
import ResidentialPage from './components/ResidentialPage';
import CommercialPage from './components/CommercialPage';
import ContactForm from './components/ContactForm';

function App() {
  return (
    <div className="App">
      <Header />
      <Nav />
      <Routes>
        <Route 
          path="/" 
          element={
            <>
              <Hero />
              <div className="content-grid">
                <div className="left-section">
                  <GalleryComponent />
                  <Testimonials />
                </div>
                <div className="right-section">
                  <Login />
                </div>
              </div>
            </>
          } 
        />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/residential" element={<ResidentialPage />} />
        <Route path="/commercial" element={<CommercialPage />} />
        <Route path="/checklist" element={<div className="page-content"><Checklist /></div>} />
        <Route path="/careers" element={<div className="page-content"><Career /></div>} />
        <Route path="/gallery" element={<div className="page-content"><GalleryPage /></div>} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
